class IconForContentType {

    constructor(){
        return contentType => {
            var icon = "file";
            switch(contentType) {
            case "image/jpg":
            case "image/jpeg":
                icon = "image";
                break;
            case "image/png":
                icon = "image";
                break;
            case "image/gif":
                icon = "image";
                break;
            case "video/mp4":
                icon = "video";
                break;
            case "video/mov":
            case "video/quicktime":
                icon = "video";
                break;
            case "application/x-shockwave-flash":
                icon = "file";
                break;
            case "x-reflow-content/channel-rss":
                icon = "rss";
                break;
            case "x-reflow/adunit":
                icon = "adunit";
                break;
            case "x-reflow/campaign":
                icon = "campaign";
                break;
            case "x-reflow/trackset":
                icon = "trackset";
                break;
            case "x-reflow/user":
                icon = "user";
                break;
            case "x-reflow/group":
                icon = "group";
                break;
            default:
                icon = "file";
                break;
            }
            return icon;
        };
    }

}

angular.module('cpm')
.filter('iconForContentType', [ () => {
    'use strict';
    return new IconForContentType();
}]);

